import { Component, inject, PLATFORM_ID, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavbarComponent } from './core/layouts/navbar/navbar.component';
import { FooterComponent } from './core/layouts/footer/footer.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { isPlatformBrowser } from '@angular/common';
import { FOOTER } from './shared/configs';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { CursorComponent } from './shared/components/cursor/cursor.component';
import { AiChatWidgetComponent } from './shared/components/ai-chat-widget/ai-chat-widget.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NavbarComponent, FooterComponent, TranslateModule, LoaderComponent, CursorComponent, AiChatWidgetComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'website';
  private translate = inject(TranslateService);
  private platformId = inject(PLATFORM_ID);
  readonly footer = FOOTER.footer;
  showScrollTop = false;

  isAppLoaded = false;

  showInitialLoader = true;

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      window.addEventListener('load', () => {

        setTimeout(() => {

          this.isAppLoaded = true;

        }, 800);

      });


      window.addEventListener('scroll', () => {
        this.showScrollTop = window.scrollY > 400;
      });
    }
  }

  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  constructor() {

    setTimeout(() => {
      this.showInitialLoader = false;
    }, 800);

    if (isPlatformBrowser(this.platformId)) {
      const savedTheme = localStorage.getItem('theme') || 'light';
      document.documentElement.setAttribute('data-theme', savedTheme);
    }

    this.translate.addLangs(['en', 'ta', 'hi']);

    this.translate.setDefaultLang('en');

    if (isPlatformBrowser(this.platformId)) {

      const savedLang = localStorage.getItem('lang') || 'en';

      this.translate.use(savedLang);

    } else {

      this.translate.use('en');
    }
  }
}
